import { Box } from '@mui/system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Modal } from '../../components/modal';
import { COLORS } from '../../theme';
import Button from '../button';
import { H2, H6 } from '../typography';

type ApplicationSentModalProps = {
  open: boolean;
  onClose: () => void;
  subtitle?: string;
};

export const ApplicationSentModal: React.FC<ApplicationSentModalProps> = ({
  open,
  onClose,
  subtitle = 'application_sent_modal_text_1'
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          padding: '50px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column'
        }}
      >
        <H2 fontWeight="bold" color={COLORS.primary}>
          {t('Application sent!')}
        </H2>
        <Box sx={{ textAlign: 'center' }}>
          <H6 fontWeight="normal">{t(subtitle)}</H6>
        </Box>
        <Button
          sx={{
            mt: 4,
            mb: 3,
            width: '100%'
          }}
          backgroundColor={COLORS.primary}
          textcolor={COLORS.white}
          bordercolor={COLORS.primary}
          onClick={onClose}
        >
          {t('Close')}
        </Button>
      </Box>
    </Modal>
  );
};
